import * as yup from 'yup';
import { ReferrerType } from 'src/constants';

export const validationSchema = yup.object({
  email: yup
    .string()
    .nullable()
    .email('Enter a valid email')
    .required("Friend's email is required"),
  name: yup.string().nullable().required("Friend's name is required"),
  note: yup
    .string()
    .test(
      'is less than 250 symbols',
      (value) => {
        const normalizedLength =
          value.value?.replace(/\s+/g, ' ').trim().length ?? 0;
        return `Please, leave a note of up to 250 symbols. You now have ${normalizedLength}.`;
      },
      function (value) {
        return !value || value.replace(/\s+/g, ' ').trim().length < 250;
      },
    )
    .optional()
    .nullable(),
  linkedIn: yup
    .string()
    .url('Enter a valid LinkedIn profile URL')
    .optional()
    .nullable()
    .when('referrerType', (referrerType, schema) => {
      const isExternalReferrer = referrerType === ReferrerType.EXTERNAL;

      if (isExternalReferrer) {
        return schema.required('LinkedIn profile is required');
      }

      return schema;
    }),
  referrerName: yup
    .string()
    .optional()
    .nullable()
    .when('referrerType', (referrerType, schema) => {
      const isExternalReferrer = referrerType === ReferrerType.EXTERNAL;

      if (isExternalReferrer) {
        return schema.required('Referrer name is required');
      }

      return schema;
    }),
  referrerCountry: yup
    .string()
    .optional()
    .nullable()
    .when('referrerType', (referrerType, schema) => {
      const isExternalReferrer = referrerType === ReferrerType.EXTERNAL;

      if (isExternalReferrer) {
        return schema.required('Referrer country is required');
      }

      return schema;
    }),
  isConsentChecked: yup
    .boolean()
    .optional()
    .nullable()
    .when('referrerType', (referrerType, schema) => {
      const isExternalReferrer = referrerType === ReferrerType.EXTERNAL;

      if (isExternalReferrer) {
        return schema.oneOf([true], 'Consent is required');
      }

      return schema;
    }),
});
